import { render, staticRenderFns } from "./SidePanelSourcedOrganizations.vue?vue&type=template&id=969a75fa&"
import script from "./SidePanelSourcedOrganizations.vue?vue&type=script&lang=js&"
export * from "./SidePanelSourcedOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports